.container {
  display: flex;
  flex-grow: 1;
  padding: 0.25rem;
  overflow: hidden;
  color: var(--on-surface);
  background: var(--dropdown-background);
  border: 1px solid var(--dropdown-separator);
  border-radius: 0.5rem;
  box-shadow: var(--shadow-small) rgba(0, 0, 0, 0.1);
}

.button {
  position: relative;
  height: 2rem;
  padding-right: 2rem;
  line-height: 1em;
  white-space: nowrap;
  appearance: none;
  background: transparent;
  border: none;
  border-radius: 0.25rem;

  &:hover {
    color: var(--primary);
  }
}

.icon {
  position: absolute;
  top: 48%;
  right: 1rem;
  width: 22px;
  transform: translate(50%, -50%);
}
